"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.growthTierConfig = void 0;
exports.growthTierConfig = {
    hasGrowthTier: true,
    showPayoutForm: true,
    showRebrandGuideAndAssetsLink: true,
};
